import React, {useEffect} from 'react';
import {RouterProvider} from 'react-router-dom';
import * as PropTypes from 'prop-types';
import {identifyAuthExistOnDeviceStart, resetDataStart} from '../redux/actions';
import {connect} from 'react-redux';
import {AppRouter} from './AppRouter';
import {RQUseGetUISystemConfigurationLookup} from '@app/reactQuery/apis';
import {isEmpty} from 'lodash';
import {LoadingSpinnerRise} from '@app/components/common/LoadingSpinnerRise';
import {useMainContext} from '@app/navigations/provider/MainProvider';
import {cleanupLocalStorage} from '@app/localStorage';
import {AppConfig} from '@app/config';
import {ROUTE_OAUTH2_LOGIN} from '@app/navigations/RoutePathConstant';

const RootNavigator = ({
  handleIdentifyUserExistOnDeviceStart,
  handleResetDataStart,
}: any) => {

  const {mainState, mainSnapshot}: any = useMainContext();
  const {uiSystemConfig}: any = mainSnapshot;

  // const {data = {}} = RQUseGetUISystemConfigurationLookup();

  const data = {'appName':'', 'logo':[], 'status':'ACTIVE'};

  useEffect(() => {
    if (!window.location.href.includes(ROUTE_OAUTH2_LOGIN)) {
      if (AppConfig.BROWSER_CACHE_ENABLE) {
        handleIdentifyUserExistOnDeviceStart();
      } else {
        cleanupLocalStorage().then(() => handleResetDataStart());
      }
    }
  }, [handleIdentifyUserExistOnDeviceStart, handleResetDataStart]);

  useEffect(() => {
    if (!isEmpty(data) && !uiSystemConfig.isFetched) {
      mainState.updateUISystemConfig({uiSystemConfig: data});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return uiSystemConfig.isFetched
    ? <RouterProvider router={AppRouter} />
    : <LoadingSpinnerRise />;
};

RootNavigator.propTypes = {
  handleIdentifyUserExistOnDeviceStart: PropTypes.func.isRequired,
  handleResetDataStart: PropTypes.func.isRequired,
};

const actions = {
  handleIdentifyUserExistOnDeviceStart: identifyAuthExistOnDeviceStart,
  handleResetDataStart: resetDataStart,
};

export default connect(null, actions)(RootNavigator);
